import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { useConfirm } from '@/components';

/** 未登録の変更がある状態で画面を離れるときの確認メッセージ（kintone 検証指摘：助成金支払日登録） */
export const UNSAVED_MESSAGE = '登録していませんがよろしいですか？';

/**
 * 未登録の変更がある間、別画面への移動（メニュー・ホーム・ブラウザの戻る）を確認ダイアログで止める。
 * ブラウザの再読み込み・タブを閉じる操作はブラウザ標準の確認を出す。
 * 同じ画面内の検索条件の変更（クエリ文字列のみの変更）は対象外（各画面の「検索」で確認する）。
 */
export function useUnsavedChangesGuard(dirty: boolean, message: string = UNSAVED_MESSAGE): void {
  const confirm = useConfirm();
  const blocker = useBlocker(({ currentLocation, nextLocation }) => dirty && currentLocation.pathname !== nextLocation.pathname);

  useEffect(() => {
    if (blocker.state !== 'blocked') return;
    let active = true;
    void confirm({ title: '確認', message, confirmLabel: '移動する', cancelLabel: 'この画面に戻る' }).then((ok) => {
      if (!active) return;
      if (ok) blocker.proceed();
      else blocker.reset();
    });
    return () => {
      active = false;
    };
  }, [blocker, confirm, message]);

  useEffect(() => {
    if (!dirty) return;
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [dirty]);
}
